<cp-popover *ngIf="isShown()" size="large" position="below" [allowAutoOrientation]="true" class="client-cost-breakdown">
  <div content>
    <table *ngIf="hasTermPolicy" class="cp-popover">
      <thead>
        <tr>
          <th *ngIf="isART" class="cp-popover__heading" colspan="2">
            {{ artDescription }}
          </th>
          <th *ngIf="!isART" class="cp-popover__heading cp-popover__sub-heading_label--bold">
            {{ term }} Year Convertible Term
          </th>
          <th class="cp-popover__heading_value cp-popover__sub-heading_value--bold">{{ termPremium | casCurrency }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="cp-popover__sub-heading_label">Premium</td>
          <td class="cp-popover__sub-heading_value">
            {{ termBasePremium | casCurrency }}
            <span *ngIf="isART">*</span>
          </td>
        </tr>
        <tr *ngIf="termHasWOP">
          <td class="cp-popover__sub-heading_label">Waiver of Premium Rider</td>
          <td class="cp-popover__sub-heading_value">{{ termWOPValue | casCurrency }}</td>
        </tr>
        <tr *ngIf="termHasECP">
          <td class="cp-popover__sub-heading_label">Extended Convertibility</td>
          <td class="cp-popover__sub-heading_value">Included</td>
        </tr>
      </tbody>
    </table>
    <table *ngIf="hasWholeLifePolicy" class="cp-popover">
      <thead>
        <tr>
          <th class="cp-popover__heading cp-popover__sub-heading_label--bold">Whole Life {{ wholeTerm }}</th>
          <th class="cp-popover__heading_value cp-popover__sub-heading_value--bold">
            {{ wholePremium | casCurrency }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="cp-popover__sub-heading_label">Premium</td>
          <td class="cp-popover__sub-heading_value">{{ wholeBasePremium | casCurrency }}</td>
        </tr>
        <tr *ngIf="wholeHasWOP">
          <td class="cp-popover__sub-heading_label">Waiver of Premium Rider</td>
          <td class="cp-popover__sub-heading_value">{{ wholeWOPValue | casCurrency }}</td>
        </tr>
        <tr *ngIf="hasGir">
          <td class="cp-popover__sub-heading_label">Guaranteed Insurability Rider</td>
          <td class="cp-popover__sub-heading_value">{{ girPremium | casCurrency }}</td>
        </tr>
        <tr *ngIf="hasRtr">
          <td class="cp-popover__sub-heading_label">Renewable Term Rider</td>
          <td class="cp-popover__sub-heading_value">{{ rtrPremium | casCurrency }}</td>
        </tr>
        <tr *ngIf="hasAlir && !hasExchange1035">
          <td class="cp-popover__sub-heading_label">Additional Life Insurance Rider</td>
          <td class="cp-popover__sub-heading_value">{{ alirPremium | casCurrency }}</td>
        </tr>
        <tr *ngIf="hasCir">
          <td class="cp-popover__sub-heading_label">Chronic Illness Rider</td>
          <td class="cp-popover__sub-heading_value">{{ cirPremium | casCurrency }}</td>
        </tr>
        <tr *ngIf="hasExchange1035TowardsPremium">
          <td class="cp-popover__heading cp-popover__heading--sub-heading cp-popover__sub-heading_label--bold">
            Paid with another policy
          </td>
          <td
            class="cp-popover__heading_value cp-popover__heading_value--sub-heading cp-popover__sub-heading_value--bold"
          >
            {{ exchange1035Premium | casCurrency }}
          </td>
        </tr>
      </tbody>
    </table>
    <table class="cp-popover cp-popover__divider">
      <tbody>
        <tr *ngIf="hasExchange1035TowardsPremium">
          <td class="cp-popover__heading cp-popover__sub-heading_label--bold">Initial premium due</td>
          <td class="cp-popover__heading_value cp-popover__sub-heading_value--bold">
            {{ totalPremium + exchange1035Premium | casCurrency }}
          </td>
        </tr>
        <tr *ngIf="!hasExchange1035TowardsPremium">
          <td class="cp-popover__heading cp-popover__sub-heading_label--bold">Total</td>
          <td class="cp-popover__heading_value cp-popover__sub-heading_value--bold">
            {{ totalPremium | casCurrency }}/{{ frequencyUnit }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div label class="cp-popover-tooltip">
    <div>
      <img class="tooltip__link-icon" src="/img/components/tooltip/money-icon.svg" />
      <span class="cp-popover-tooltip__text-label text-link text-link--secondary">Cost Breakdown</span>
    </div>
  </div>
</cp-popover>
